/*
  Users service - migrated from jwt-bch-frontend
*/

const SERVER = process.env.REACT_APP_AUTHSERVER || process.env.AUTHSERVER

export const updateUser = async (userData, token) => {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ user: userData })
  }
  const resp = await fetch(`${SERVER}/users/`, options)
  if (!resp.ok) {
    const error = await resp.json()
    throw new Error(error.message || 'Failed to update user')
  }
  return await resp.json()
}
